/*
 * @Author: yi
 * @Date: 2023-11-13 15:26:54
 * @LastEditors: yi
 * @LastEditTime: 2023-11-29 13:43:36
 * @Description: file content
 */
import Account from "../pages/Account";
import Cardsecret from "../pages/Cardsecret";
import Invite from "../pages/Invite";
import VipInfo from "../pages/Vip"
// import Welcome from "../pages/Welcome"

const routes = [
    {
        path:'/',
        title:'账户中心',
        element: <Account />,
    },
    {
        path:'/secret',
        title:'兑换卡密',
        element: <Cardsecret />,
    },
    {
        path:'/invite',
        title:'填写邀请码',
        element: <Invite  />,
    },
    {
        path:'/vip',
        title:'VIP',
        element: <VipInfo  />,
    },
    // {
    //     path:'/welcome',
    //     title:'Welcome',
    //     element: <Welcome  />,
    // },
]

export default routes